import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostListener
} from '@angular/core';

import { NetworkService } from '../../../core/services/network.service';
import { ScreenSizeService } from '../../../core/services/screen-size.service';
import { UserService } from '../../../core/services/user.service';
import { EventsService } from '../../../core/services/events.service';
import { AuthenticationService} from '../../../core/services/authentication.service';
import { HEADER_MENU_OPENED, HEADER_MENU_CLOSED } from '../../../app.constants';

@Component({
  selector: 'header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderMenuComponent implements OnInit {
  isActive: boolean = false;
  isMobileMenuSwitched: boolean = false;
  categories = [];

  constructor (
      private network: NetworkService,
      private screenSizeService: ScreenSizeService,
      private eventBus: EventsService,
      private userService: UserService,
      private authService: AuthenticationService
    ) {}

  ngOnInit () {
    this.network
      .fetchCategories()
      .then(categories => {
        this.categories = categories;
      });
  }

  @HostListener('document:click') closeMenu(){
    if (this.isActive) this.switchMenu();
  }

  switchMenu ($event?) {

    if ($event) {
      $event.stopPropagation();
    }

    if (this.isMobileMenuSwitched) {
      this.switchMobileMenu();
    }

    this.isActive = !this.isActive;

    const event = this.isActive ? HEADER_MENU_OPENED : HEADER_MENU_CLOSED;
    this.eventBus.trigger(event);
  }

  switchMobileMenu ($event?) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this.isMobileMenuSwitched = !this.isMobileMenuSwitched;
  }

  isLoggedIn () {
    return this.authService.isAuthenticated();
  }

  isMobileMenuVisible () {

    if (this.screenSizeService.isLarge()) {
      return false;
    }

    return !this.isMobileMenuSwitched;
  }

  logOut () {
    this.authService.logOut();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/header/menu/header-menu.component.ts